import { render, staticRenderFns } from "./ContainerResourceLimit.vue?vue&type=template&id=068ed391&"
import script from "./ContainerResourceLimit.vue?vue&type=script&lang=js&"
export * from "./ContainerResourceLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports